import { render, staticRenderFns } from "./CurrentDistribution.vue?vue&type=template&id=545580b4&scoped=true"
import script from "./CurrentDistribution.vue?vue&type=script&lang=js"
export * from "./CurrentDistribution.vue?vue&type=script&lang=js"
import style0 from "./CurrentDistribution.vue?vue&type=style&index=0&id=545580b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545580b4",
  null
  
)

export default component.exports